"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
// GENERATED FILE. DO NOT EDIT MANUALLY.
module.exports = '1.2.0';
//# sourceMappingURL=telemetryVersion.js.map